// extracted by mini-css-extract-plugin
module.exports = {"ra-illustration":"ra-illustration_ra-illustration__w2BZt"};